import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getRatingScale, saveBatchRatingScale } from '../../api/ratingScale';
import type { RatingScale } from '../../types/RatingScale';
import { t } from '../../i18n/t';

const columnDefs: ColDef<RatingScale>[] = [
  {
    field: 'ratingOrder',
    headerName: t('ratingScale.columns.ratingOrder'),
    width: 110,
    cellDataType: 'number',
    editable: (params: EditableCallbackParams<RatingScale>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  { field: 'maalot', headerName: t('ratingScale.columns.maalot'), width: 110, editable: true },
  { field: 'midroog', headerName: t('ratingScale.columns.midroog'), width: 110, editable: true },
  { field: 'moodys', headerName: t('ratingScale.columns.moodys'), width: 110, editable: true },
  { field: 'sp', headerName: t('ratingScale.columns.sp'), width: 110, editable: true },
  { field: 'fitch', headerName: t('ratingScale.columns.fitch'), width: 110, editable: true },
  { field: 'fitchShort', headerName: t('ratingScale.columns.fitchShort'), width: 120, editable: true },
  { field: 'moodysShort', headerName: t('ratingScale.columns.moodysShort'), width: 120, editable: true },
  { field: 'spShort', headerName: t('ratingScale.columns.spShort'), width: 120, editable: true },
];

const newRowDefaults = (): Partial<RatingScale> => ({
  ratingOrder: 0,
  maalot: null,
  midroog: null,
  moodys: null,
  sp: null,
  fitch: null,
  fitchShort: null,
  moodysShort: null,
  spShort: null,
});

export function RatingScalePage() {
  return (
    <LopCrudPage<RatingScale>
      resourceCode="ratingScale"
      titleKey="ratingScale.pageTitle"
      idField="ratingOrder"
      getRows={getRatingScale}
      saveBatch={(added, modified, deletedIds) => saveBatchRatingScale(added, modified, deletedIds as number[])}
      columnDefs={columnDefs}
      newRowDefaults={newRowDefaults}
    />
  );
}
